<!--
  NOTE this is only for true or false values or for options that are selectable
-->
<template>
  <button class="toggle-button" :class="[toggleState]" @click="handleClick">
    <span class="toggle-button__left-label">{{ leftLabel }}</span>
    <span class="toggle-button__right-label">{{ rightLabel }}</span>
    <span class="toggle-button__selection"></span>
  </button>
</template>

<script>
export default {
  props: {
    leftLabel: {
      type: String,
      default: 'On'
    },
    rightLabel: {
      type: String,
      default: 'Off'
    },
    toggleValue: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    toggleState () {
      return this.toggleValue ? 'toggle-button--true' : 'toggle-button--false'
    }
  },
  methods: {
    handleClick () {
      this.$emit('toggle')
    }
  }
}
</script>

<style lang="scss">
.toggle-button {
  display: inline-flex;
  position: relative;
  border-radius: 5px;
  border: solid 1px color(grays, light);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);
  background: color(grays, light);
  height: rem(30);
  font-size: rem(16);
  line-height: rem(19);
  font-weight: normal;
  padding: 0;
  margin: 0;
  overflow: hidden;
  bottom: 3px;

  &:focus, &:active {
    outline: none;
  }

  &__left-label, &__right-label {
    width: 50%;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    display: block;
    position: relative;
    z-index: 2;
    color: color(grays, almost-white);
    padding: rem(1) rem(15);
  }

  &__selection {
    display: block;
    position: absolute;
    height: rem(30);
    transition: transform 0.4s;
    width: calc(50% - 1px);
    top: 1px;
    left: 1px;
    z-index: 1;
    background: color(blue-grey, very-dark);
    border-radius: 3px;
  }

  &--true {
    .toggle-button__selection {
      transform: translateX(0);
    }
  }

  &--false {
    .toggle-button__selection {
      transform: translateX(100%);
    }
  }
}
</style>




// WEBPACK FOOTER //
// ToggleButton.vue?7eeed613